import { basePaths } from 'app-constants';

let prefix;

export const setCaseUrlPrefix = slug => {
  prefix = slug;
};

export default function caseUrl(id = '') {
  return (
    id &&
    [prefix, basePaths.cases.replace(/^\//, ''), id]
      .join('/')
      .replace(/\/+$/, '')
  );
}

export function caseCitatorUrl(id) {
  return [caseUrl(id), 'citator'].join('/').replace(/\/+$/, '');
}

export const caseSearchUrl = caseUrl('search');
